import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowsHide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowsHide"><Path d="M9 16.5L12 13.5L15 16.5" stroke="currentColor"/><Path d="M15 7.5L12 10.5L9 7.5" stroke="currentColor"/><Path d="M12 21V14" stroke="currentColor"/><Path d="M12 10V3" stroke="currentColor"/><Path d="M8.0002 4.5H2.5V19.5H8" stroke="currentColor"/><Path d="M16 4.5H21.5V19.5H16" stroke="currentColor"/></CentralIconBase>;
});

export default IconArrowsHide;
